module.exports = __webpack_public_path__ + "img/19.278b46b1.png";